
















import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import UserTerm from "@/components/UserTerm.vue";

@Component({
  components: {
    UserTerm,
  },
})
export default class Modal extends Vue {
  @Prop(Boolean) public isOpen: boolean = false;

  public closeModal() {
    this.$emit("close-modal");
  }
}
